//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import startimg from '@/assets/dice/start.png'
import active from '@/assets/dice/active.png'
import oddimg from '@/assets/dice/odd.png'
import evenimg from '@/assets/dice/even.png'
import unknownimg from '@/assets/dice/unknown.png'
import unknownimg2 from '@/assets/dice/unknown2.png'
import prize1 from '@/assets/dice/prize1.png'
import prize2 from '@/assets/dice/prize2.png'
import down from '@/assets/dice/icon_down.png'
import down2 from '@/assets/dice/icon_down2.png'
import icondice from '@/assets/dice/icon_dice.png'
import right from '@/assets/dice/icon_right.png'
import left from '@/assets/dice/icon_left.png'
import up from '@/assets/dice/icon_up.png'
import pointer from '@/assets/dice/pointer.png'
import Box from './box'
export default {
  props: {
    activeindex: {
      default: 0
    }
  },
  components: {},
  data () {
    return {
      startimg: startimg,
      active: active,
      oddimg: oddimg,
      evenimg: evenimg,
      prize1: prize1,
      prize2: prize2,
      down: down,
      down2: down2,
      right: right,
      left: left,
      up: up,
      icondice: icondice,
      unknownimg: unknownimg,
      unknownimg2: unknownimg2,
      pointer: pointer
    }
  },
  created () {
  },
  mounted () {
  },
  watch: {
    activeindex: function (val) {
      // console.log(val)
      // this.pathList.forEach((el,index)=>{
      //   if (el.cellnum==val) {

      //   }
      // })
    }
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    }
  },
  methods: {
  }
}
